var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"links"},[_c('FooterLinks')],1),_c('div',{staticClass:"mb-5"},[_c('FooterNav')],1),_c('p',{staticClass:"text-center"},[_c('small',[_vm._v("Copyrights "+_vm._s(_vm.yearString)+" @ L'tas")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }